var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_vm._v("no "),_c('span',[_vm._v("calories")])]),_vm._v(" "),_c('p',[_vm._v("no "),_c('span',[_vm._v("sweeteners")])]),_vm._v(" "),_c('p',[_vm._v("all "),_c('span',[_vm._v("smiles"),_c('span',{staticClass:"super"},[_vm._v("™")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212f11b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllSmiles.vue
// module id = null
// module chunks = 